interface Position {
  position: 'top' | 'bottom' | 'left' | 'right';
  offsetBlock?: number;
  offsetInline?: number;
  maxHeight?: number;
  maxWidth?: number;
  useHighlight?: boolean;
}

export interface TooltipPosition {
  desktop: Position;
  tablet: Position;
  mobile: Position;
}
export interface Step {
  title: string;
  content: string[];
  callback?: string;
  elementIdentifier?: string;
  tooltipPosition?: TooltipPosition;
  lastStepIsInAnotherPage?: boolean;
  overflowEnabled?: boolean;
  useBoundary?: boolean;
  isDefaultPosition?: boolean;
  zIndex?: number;
  usePaddingBlock?: boolean;
  usePaddingInline?: boolean;
  isConditional?: boolean;
  conditionCallback?: string;
}

export interface TourState {
  numberOfSteps: number;
  hasNextStep: boolean;
  hasPreviousStep: boolean;
  steps: Step[];
  currentStep: number;
  isActive: boolean;
  intervalId: any;
  lastStepIsInAnotherPage?: boolean;
}

const state: TourState = {
  numberOfSteps: 0,
  hasNextStep: false,
  hasPreviousStep: false,
  steps: [],
  currentStep: 0,
  isActive: false,
  intervalId: '',
};

export default state;
